import { AgronomicInputs } from 'base/types/RecommendationCropwise';
import { CropConstants } from './constants/Crop';

/**
 * Brazil soybean maturity groups are shown as a letter-suffixed number: the
 * decimal part picks the band (C early, M medium, L late).
 */
export const formatSoybeanMgValue = (value: number): string => {
  const whole = Math.floor(value);
  const decimal = Math.round((value - whole) * 10);
  if (decimal <= 3) {
    return `${whole}C`;
  }
  if (decimal <= 6) {
    return `${whole}M`;
  }
  return `${whole}L`;
};

/**
 * The maturity group as the grower sees it. Brazil has no FAO rating, so this
 * is what stands in for it there. The solution carries the value under one of
 * four keys depending on how it was created, hence the fallback chain.
 *
 * Returns undefined when nothing was selected, so callers can either show a
 * placeholder or leave the field out entirely.
 */
export const getMaturityGroupDisplay = (
  isBrazilCountry: boolean,
  cropName: string | undefined,
  agronomicInputs: AgronomicInputs | undefined
): string | undefined => {
  const rawValue =
    agronomicInputs?.maturityGroup ??
    agronomicInputs?.brazilMaturityGroup ??
    agronomicInputs?.selectedMaturityGroup ??
    agronomicInputs?.soybeanMgRange;

  if (isBrazilCountry && cropName?.toLowerCase() === CropConstants.SOYBEANS_SMALLCASE) {
    if (Array.isArray(rawValue) && rawValue.length === 2) {
      return `${formatSoybeanMgValue(Number(rawValue[0]))} - ${formatSoybeanMgValue(
        Number(rawValue[1])
      )}`;
    }
    return rawValue ? String(rawValue) : undefined;
  }

  if (rawValue === undefined || rawValue === null) {
    return undefined;
  }

  const text = String(rawValue).trim();
  return text.length ? text : undefined;
};
